var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconFeatherUserCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 36.621 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3,
    transform: "translate(0 -3)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24 31.5v-3a6 6 0 0 0-6-6H7.5a6 6 0 0 0-6 6v3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.75 10.5a6 6 0 1 1-6-6 6 6 0 0 1 6 6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.5 16.5l3 3 6-6"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconFeatherUserCheck);
export default __webpack_public_path__ + "static/media/icon-feather-user-check.04dded6c5d97acd4defa1e92f36c51bf.svg";
export { ForwardRef as ReactComponent };